import React, { useRef, useState, useEffect, Fragment } from 'react';
import {Link} from "react-router-dom"
import {Card, Image} from "semantic-ui-react"
import {observer} from "mobx-react"
import ImageWithFallback from "components/ImageWithFallback"
import shop from "shop/shop"
import categoryStore from "stores/categoryStore"
import "./CategorySlider.scss"

const CategorySlider = observer(({ firstCategory, categoryforCardsLaboratory, categoryforCardsMedicine, className = "", orderMode}) => {

  const scrollRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const [scrollWidth, setScrollWidth] = useState(null);

  const scroll = (scrollOffset) => {
    scrollRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
  };

  useEffect(() => {
    const updateScrollWidth = () => {
      if (scrollWrapperRef.current) {
        const left = scrollWrapperRef.current.getBoundingClientRect().left;
        const vw = window.visualViewport ? window.visualViewport.width : window.innerWidth;
        setScrollWidth(`${vw - left}px`);
      }
    };

    requestAnimationFrame(updateScrollWidth);
    window.addEventListener('resize', updateScrollWidth);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateScrollWidth);
    }
    return () => {
      window.removeEventListener('resize', updateScrollWidth);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateScrollWidth);
      }
    };
  }, []);

  let base = "";
  let parents = [];
  if (firstCategory && firstCategory.getParents) {
    parents = firstCategory.getParents();
    base = `/collection/${parents.map(id => `${id}/`).join("")}${firstCategory.map_id}/`;
  } else {
    base = `/collection/`;
  }
  console.log("firstCategory", firstCategory, "parents", parents, "base", base);
  return (
    <div className="relative w-100 CategorySlider">
      <div className="flex flex-row justify-start items-start mb3" style={{ gap: "2.5rem" }}>
        <p className="f2 fw7  pt3 CategorySlider__titlePrimary">
          {firstCategory && firstCategory.map_id == 40
            ? translate("Produktkategorien Labor")
            : firstCategory && firstCategory.map_id == 49
            ? translate("Produktkategorien Medizin")
            : translate("Kategorien")}
        </p>
       <div className="flex flex-row justify-start items-start mt3" style={{ gap: "0.5rem" }}>
        <button className="CategorySlider__nav-btn" onClick={() => scroll(-300)}>
          <p>❮</p>
        </button>
        <button className="CategorySlider__nav-btn" onClick={() => scroll(300)}>
          <p>❯</p>
        </button>
      </div>
      </div>



      <div
        ref={scrollWrapperRef}
        className="CategorySlider__scroll-wrapper"
        style={scrollWidth ? { width: scrollWidth } : {}}
      >
        <div ref={scrollRef} className="CategorySlider__scroll-container">
          {firstCategory && firstCategory.children && firstCategory.children.map(category => {
            if (shop.config.plugin && shop.config.plugin.SEOCategoryLink) {
              const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map(id => `${id}/`).join("") + firstCategory.map_id + `/${category.map_id}`];
              base = `/collection/${seoCategory.textpath.substring(1)}`;
            } else {
              base = `/collection/${parents.map(id => `${id}/`).join("")}${category.map_id}/`;
            }
            return (
              <Fragment key={category.map_id}>
                <Link to={base} className={`CategoryCardTrend ${className}`}>
                <div
                  className={`CategoryCardTrend ${className}`} as={Link} to={base}
                >
                  <ImageWithFallback
                    className="CategorySlider__image"
                    src={category.img_src}
                    fallback={"/image/Rechteck 851.png"}
                  />
                  <p className="tc f4 b color-primary pt3 CategorySlider__title">{category.title}</p>
                </div>
                </Link>
              </Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default CategorySlider;



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/plugin/CategoryShortcuts/CategorySlider.js